import { AlertTriangle } from 'lucide-react';

function ScoreRing({ score }) {
  const pct = Math.round((score || 0) * 100);
  const radius = 34;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (pct / 100) * circumference;
  const color = pct >= 80 ? 'var(--success)' : pct >= 60 ? 'var(--warning)' : 'var(--danger)';

  return (
    <div className="quality-ring">
      <svg width="80" height="80" viewBox="0 0 80 80">
        <circle
          cx="40" cy="40" r={radius}
          fill="none" stroke="var(--border)" strokeWidth="6"
        />
        <circle
          cx="40" cy="40" r={radius}
          fill="none" stroke={color} strokeWidth="6"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <div className="quality-ring-label" style={{ color }}>
        {pct}%
      </div>
    </div>
  );
}

export default function QualityReport({ report }) {
  if (!report) {
    return <p style={{ color: 'var(--text-dim)' }}>Aucun rapport de qualité disponible.</p>;
  }

  const score = report.quality_score || 0;
  const completeness = report.extraction_completeness || 0;
  const elements = report.structural_elements || {};
  const wc = report.word_count || {};
  const warnings = report.warnings || [];

  const scoreLabel =
    score >= 0.8 ? 'Qualité excellente' :
    score >= 0.6 ? 'Qualité acceptable' :
    'Qualité insuffisante';

  return (
    <div className="quality-report">
      <div className="quality-score-card">
        <ScoreRing score={score} />
        <div className="quality-details">
          <h3>{scoreLabel}</h3>
          <p>
            Complétude : {Math.round(completeness * 100)}% | Méthode : {report.method || '-'}
          </p>
        </div>
      </div>

      <div className="quality-grid">
        <div className="quality-stat">
          <div className="quality-stat-value">{wc.extracted ?? '-'}</div>
          <div className="quality-stat-label">Mots extraits</div>
        </div>
        <div className="quality-stat">
          <div className="quality-stat-value">{wc.expected ?? '-'}</div>
          <div className="quality-stat-label">Mots attendus</div>
        </div>
        <div className="quality-stat">
          <div className="quality-stat-value">{elements.headings ?? 0}</div>
          <div className="quality-stat-label">Titres</div>
        </div>
        <div className="quality-stat">
          <div className="quality-stat-value">{elements.paragraphs ?? 0}</div>
          <div className="quality-stat-label">Paragraphes</div>
        </div>
        <div className="quality-stat">
          <div className="quality-stat-value">{elements.tables ?? 0}</div>
          <div className="quality-stat-label">Tableaux</div>
        </div>
        <div className="quality-stat">
          <div className="quality-stat-value">{elements.lists ?? 0}</div>
          <div className="quality-stat-label">Listes</div>
        </div>
      </div>

      {warnings.length > 0 && (
        <>
          <h3 style={{ fontSize: 14, fontWeight: 600, marginTop: 8 }}>
            Avertissements ({warnings.length})
          </h3>
          <div className="quality-warnings">
            {warnings.map((w, i) => (
              <div key={i} className="quality-warning-item">
                <AlertTriangle size={14} style={{ flexShrink: 0, marginTop: 2 }} />
                <span>{w}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
